import initialAuthState from "../data/initialAuthState";

function authReducer(state, action) {
    switch (action.type) {
        case 'refreshUserInfo' : {
            return {
                ...state,
                user : (action.payload.user ? action.payload.user : state.user),
                token : (action.payload.token ? action.payload.token : state.token)
            };
        }
        case 'loginSuccess': {
            return {
                ...state,
                fetching : false,
                error: undefined,
                user : action.payload.user ?? state.user,
                token : action.payload.token ?? state.token,
                refresh_token : action.payload.refreshToken ?? action.payload.refresh_token ?? state.refresh_token
            };
        }
        case 'loginFailed': {
            return {
                ...state,
                fetching: false,
                error: action.payload
            };
        }
        case 'loginPending': {
            return {
                ...state,
                fetching: true
            };
        }
        case 'loginOut':
        case 'logout': {
            return {
                ...state,
                user: {},
                error: undefined,
                token: undefined,
                refresh_token: undefined,
                fetching: false,
            };
        }
        default: {
            throw new Error('unhandled action');
        }
    }
}

export default authReducer;